import Api from '~/api';
import SocketIO from 'socket.io-client';
import groupBy from 'lodash.groupby';
import keyBy from 'lodash.keyby';
import parseContests from './parse-contests';
import { contestsShow } from '~/store/actions/contests';
import getContestWithFlattenedRounds from '../../../utils/getContestWithFlattenedRounds';

const { REACT_APP_SOCKET_URL } = process.env;

const Updater = (dispatch) => {
  let lastSelectedEventId = null;
  let lastError = null;
  let contestsData = [];
  let liveData = {};
  let roundsLiveData = [];

  const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws';

  const port = window.location.port ? ':' + window.location.port : '';

  const socket = SocketIO(
    REACT_APP_SOCKET_URL === '/' ? `${protocol}://${window.location.hostname}${port}` : REACT_APP_SOCKET_URL,
    { transports: ['websocket'] },
  );
  console.log('connected');

  socket
    .on('UPDATE_ROUNDS', (payload) => {
      const { eventId, rounds = [] } = payload;

      if (eventId !== lastSelectedEventId || !Array.isArray(rounds)) {
        return;
      }

      roundsLiveData = rounds;
    })
    .on('error', (err) => {
      if (`${err}` === 'Invalid namespace') {
        return;
      }
      lastError = err;
      roundsLiveData = [];
    });

  socket
    .on('UPDATE_HEATS', (payload) => {
      const { eventId, heatsUpdate = [] } = payload;

      if (eventId !== lastSelectedEventId || !Array.isArray(heatsUpdate)) {
        return;
      }

      const updates = groupBy(
        heatsUpdate.map(({ heatUpdate }) => heatUpdate),
        'externalContestId',
      );

      liveData = Object.keys(updates).reduce((obj, key) => {
        const byRoundId = groupBy(updates[key], 'externalRoundId');

        obj[key] = Object.keys(byRoundId).reduce((obj, key) => {
          obj[key] = keyBy(byRoundId[key], 'externalId');

          return obj;
        }, {});

        return obj;
      }, {});
    })
    .on('error', (err) => {
      if (`${err}` === 'Invalid namespace') {
        return;
      }

      lastError = err;
      liveData = {};
    });

  const getLastError = () => {
    const err = lastError;
    lastError = null;

    return err;
  };

  return async ({
    error,
    eventId,
    selectedContestId: prevSelectedContestId,
    selectedRoundId: prevSelectedRoundId,
    selectedHeatId: prevSelectedHeatId,
    autoSwitch,
  }) => {
    let res = {};

    try {
      const eventChanged = lastSelectedEventId !== eventId;
      lastSelectedEventId = eventId;

      if (eventChanged || !contestsData.length || (autoSwitch && roundsLiveData.length > 0)) {
        contestsData = await Api.contestsShow({
          eventId,
        });

        if (contestsData) {
          contestsData = contestsData.map((contest) => getContestWithFlattenedRounds(contest));
        }
      }

      if (roundsLiveData && roundsLiveData.length > 0) {
        contestsData = contestsData.map((contest) => {
          contest.rounds = contest.rounds.map((round) => {
            const updatedRound = roundsLiveData.find((item) => item.externalId === round.externalId);
            if (updatedRound) {
              return {
                ...round,
                ...updatedRound,
              };
            }
            return round;
          });
          return contest;
        });
      }

      res = parseContests({
        contestsData,
        liveData,
        selectedContestId: autoSwitch ? undefined : prevSelectedContestId,
        selectedRoundId: autoSwitch ? undefined : prevSelectedRoundId,
        selectedHeatId: autoSwitch ? undefined : prevSelectedHeatId,
      });
    } catch (err) {
      if (!Array.isArray(contestsData)) {
        contestsData = [];
      }

      lastError = err;
    }

    const {
      contests = [],
      contestsByExternalId = {},
      selectedContestId = prevSelectedContestId,
      selectedRoundId = prevSelectedRoundId,
      selectedHeatId = prevSelectedHeatId,
    } = res || {};

    contestsData = contests;

    const forceRoundUpdate =
      (roundsLiveData && roundsLiveData.length > 0) || (autoSwitch && selectedRoundId !== prevSelectedRoundId);
    if (roundsLiveData) {
      roundsLiveData = [];
    }

    return dispatch(
      contestsShow({
        error: error || getLastError(),
        contests,
        contestsByExternalId,
        selectedContestId,
        selectedRoundId,
        selectedHeatId,
        forceRoundUpdate,
      }),
    );
  };
};

export default Updater;
